// ONE place for the Firebase project settings (used by the browser SDK in lib/firebase.ts AND
// by the server-side token check in lib/firebase-admin.ts, so they can never disagree).
//
// Firebase Console -> Project settings (gear icon) -> General -> "Your apps" -> Web app ->
// SDK setup and configuration -> "Config". Paste the values below. These web config values are
// NOT secret (every visitor's browser downloads them), so it is fine to keep them in the code.
//
// The values are written directly in this file (no .env needed), so the app cannot crash from
// a missing .env / build variable. NEXT_PUBLIC_FIREBASE_* env vars, if set at build time, still
// override them. This is Animora's OWN Firebase project - if you ever fork this code for a
// different project, change the values below.

export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || 'AIzaSyC-dSTlNseUXBgxJhAKGFXAsoeb-S9SnFQ',
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || 'animorasocial.firebaseapp.com',
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'animorasocial',
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '660756090277',
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || '1:660756090277:web:2716f05597f6b9c0a6ac4c',
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || '',
}

// True whenever the required fields aren't set yet - either never filled in (empty) or still
// carrying a literal "PASTE_..." placeholder - so lib/firebase.ts can show a clear "Firebase
// isn't configured" state in the browser instead of silently misbehaving either way.
const REQUIRED_KEYS: (keyof typeof firebaseConfig)[] = ['apiKey', 'authDomain', 'projectId', 'appId']
export const firebaseConfigIsPlaceholder = REQUIRED_KEYS.some((k) => {
  const v = String(firebaseConfig[k] || '')
  return !v || v.startsWith('PASTE_') || v.includes('PASTE_')
})
